var zh = {
  search: '搜尋',
  off: '關閉',
  minutesAndSecondsAbbr: '{{m}}分{{s}}秒',
  minutesAbbr: '{{m}}分',
  minRange: '至少間隔{{seconds}}秒',
  minMonth: '至少間隔{{months}}月',
  year: '年',
  month: '月',
  secondsAbbr: '{{s}}秒',
  'relTime_-s': '秒前',
  'relTime_-m': '分前',
  'relTime_-h': '小時前',
  'relTime_-d': '天前',
  relTime_s: '秒後',
  relTime_m: '分後',
  relTime_h: '小時後',
  relTime_d: '天後',
  clearFilter: '清除',
  absolute: '絕對時間',
  relative: '相對時間',
  now: '現在',
  relativeToNow: '選取現在',
  loading: '載入中',
  noContent: '無',
  hideAll: '全部隱藏',
  showAll: '全部顯示',
  rowsPerPage: '每頁行數',
  noOptions: '無選項',
  cancel: '取消',
  confirm: '確認',
  submit: '確認',
  logout: '登出',
  columns: '欄位',
  density: '密度',
  compact: '密集',
  standard: '標準',
  resetTable: '重設',
  'block.paragraph': '一般文字',
  'block.h1': '標題 1',
  'block.h2': '標題 2',
  'block.h3': '標題 3',
  'block.ul': '項目清單',
  'block.ol': '編號清單',
  'block.check-list': '檢查清單',
  'block.quote': '引用',
  'block.code': '程式碼',
  undo: '復原',
  redo: '取消復原',
  bold: '粗體',
  italic: '斜體',
  underline: '底線',
  strikethrough: '刪除線',
  code: '程式碼區塊',
  link: '連結',
  clearFormat: '清除格式',
  export: '輸出',
  'export.all': '所有資料',
  'export.currentPage': '目前分頁',
  'table.insertRowAbove': '向上插入 {{n}} 列',
  'table.insertRowBelow': '向下插入 {{n}} 列',
  'table.insertColumnLeft': '向左插入 {{n}} 欄',
  'table.insertColumnRight': '向右插入 {{n}} 欄',
  'table.deleteRow': '刪除列',
  'table.deleteColumn': '刪除欄',
  'table.deleteTable': '刪除表格',
  noFiles: '檔案為空',
  'fileUploader.drop-failed': '檔案拖曳失敗',
  'fileUploader.too-many-files': '只允許上傳 {{n}} 個檔案',
  'fileUploader.file-too-large': '檔案須小於 {{size}}',
  'fileUploader.file-exists': '{{fileName}} 已存在',
  'fileUploader.file-invalid-type': '無效的檔案格式',
  copyToClipboard: '複製到剪貼簿',
  uploadedFile: '上傳檔案',
  uploadedFile_plural: '上傳檔案',
  name: '檔案名稱',
  size: '檔案大小',
  createdAt: '建立時間',
  updatedAt: '更新時間'
};

export { zh as default };
